module.exports = __webpack_public_path__ + "img/sign-out.46ef1ddf.svg";